import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const font = {
  mono:      '"JetBrains Mono", monospace',
  condensed: '"Barlow Condensed", sans-serif',
  body:      '"Barlow", sans-serif',
};

const WaitlistPage = () => {
  const { isLoggedIn, user, logout, authToken, setUser, setIsBeta } = useContext(AuthContext);
  const navigate = useNavigate();
  const [checking, setChecking] = useState(false);
  const [denied, setDenied]     = useState(false);

  const checkAccess = async () => {
    setChecking(true);
    setDenied(false);
    try {
      const res  = await fetch(`${BACKEND_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      const data = await res.json();
      setUser(data);
      if (data.is_beta === true) {
        setIsBeta(true);
        navigate('/');
      } else {
        setDenied(true);
      }
    } catch {
      setDenied(true);
    } finally {
      setChecking(false);
    }
  };

  return (
    <div style={{ background: '#000', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@900&family=Barlow:wght@300;400&family=JetBrains+Mono:wght@400;700&display=swap');
        .bgn-wl-btn:hover { background: #fff !important; color: #000 !important; }
        .bgn-wl-ig:hover  { border-color: #E1306C !important; color: #E1306C !important; }
        .bgn-wl-msg:hover { border-color: #FFD700 !important; color: #FFD700 !important; }
      `}</style>

      <img
        src="https://customer-assets.emergentagent.com/job_gamers-unite/artifacts/6of96a1d_bgn%20logo.png"
        alt="BGN"
        style={{ width: 72, marginBottom: '2rem', filter: 'grayscale(100%)' }}
      />

      <div style={{ fontFamily: font.mono, fontSize: '0.58rem', color: '#333', letterSpacing: '0.2em', marginBottom: '1rem' }}>
        // PRIVATE BETA
      </div>

      <h1 style={{ fontFamily: font.condensed, fontWeight: 900, fontSize: 'clamp(2.5rem, 8vw, 5rem)', color: '#fff', letterSpacing: '-0.02em', textAlign: 'center', marginBottom: '1rem', lineHeight: 1 }}>
        {isLoggedIn ? "YOU'RE ON THE LIST" : "BLACK GAMERS NETWORK"}
      </h1>

      <p style={{ fontFamily: font.body, fontWeight: 300, fontSize: '1rem', color: '#555', textAlign: 'center', maxWidth: 460, lineHeight: 1.8, marginBottom: '2.5rem' }}>
        {isLoggedIn && user
          ? `Hey @${user.login} — you're registered. To get beta access, DM us on Instagram or send us a message below.`
          : 'BGN is currently in private beta. Connect your Twitch account to register, then reach out to get access.'}
      </p>

      {!isLoggedIn ? (
        <button
          className="bgn-wl-btn"
          onClick={() => { window.location.href = `${BACKEND_URL}/api/auth/twitch/login`; }}
          style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#9146FF', color: '#fff', border: 'none', padding: '0.85rem 2rem', fontFamily: font.mono, fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.1em', cursor: 'pointer', marginBottom: '3rem', transition: 'all 0.15s' }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z"/></svg>
          CONNECT WITH TWITCH
        </button>
      ) : (
        <>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', width: '100%', maxWidth: 360, marginBottom: '3rem' }}>
            <a
              href="https://www.instagram.com/blackgamersnetwork/"
              target="_blank"
              rel="noopener noreferrer"
              className="bgn-wl-ig"
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, background: 'none', border: '1px solid #222', color: '#888', padding: '0.8rem 1.5rem', fontFamily: font.mono, fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.1em', cursor: 'pointer', textDecoration: 'none', transition: 'all 0.15s' }}
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              DM US ON INSTAGRAM
            </a>
            <button
              className="bgn-wl-msg"
              onClick={() => navigate('/contact')}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, background: 'none', border: '1px solid #222', color: '#888', padding: '0.8rem 1.5rem', fontFamily: font.mono, fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.1em', cursor: 'pointer', transition: 'all 0.15s' }}
            >
              SEND US A MESSAGE →
            </button>
          </div>
          <button
            onClick={checkAccess}
            disabled={checking}
            style={{ background: '#FFD700', color: '#000', border: 'none', padding: '0.8rem 2rem', fontFamily: font.mono, fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.1em', cursor: checking ? 'default' : 'pointer', opacity: checking ? 0.7 : 1, marginBottom: '0.75rem', transition: 'all 0.15s' }}
          >
            {checking ? 'CHECKING…' : 'CHECK MY ACCESS'}
          </button>
          {denied && (
            <p style={{ fontFamily: font.mono, fontSize: '0.6rem', color: '#444', letterSpacing: '0.1em', marginBottom: '1.5rem' }}>
              NOT APPROVED YET — DM US TO GET IN
            </p>
          )}
          <button
            onClick={logout}
            style={{ background: 'none', border: 'none', fontFamily: font.mono, fontSize: '0.58rem', color: '#2a2a2a', cursor: 'pointer', letterSpacing: '0.1em' }}
          >
            SIGN OUT
          </button>
        </>
      )}
    </div>
  );
};

export default WaitlistPage;
